import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { AvatarSizeType, AvatarShapeType, AvatarColorType } from '../../../types';
import { AVATAR_COLORS_MAP, AVATAR_SIZES_MAP } from '../../../constants';
import { IconUIComponent } from '../icon/icon.component';
import { ImageUIComponent } from '../image/image.component';
import { AvatarTakeFirstLetterPipe } from './pipes/avatar-take-first-letter.pipe';

const DEFAULT_AVATAR_SIZE: AvatarSizeType = 50;

@Component({
  selector: 'fr8bot-ui-avatar',
  imports: [IconUIComponent, ImageUIComponent, AvatarTakeFirstLetterPipe],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarUIComponent {
  readonly size = input<AvatarSizeType>(DEFAULT_AVATAR_SIZE);
  readonly shape = input<AvatarShapeType>('square');
  readonly color = input<AvatarColorType>('default');

  readonly avatarUrl = input<string | null>(null);
  /** Hover highlight and pointer cursor — only where the avatar itself opens or changes something. */
  readonly interactive = input(false, { transform: booleanAttribute });

  readonly firstName = input<string | null>(null);
  readonly lastName = input<string | null>(null);
  /** When set, wins over `firstName`/`lastName`. */
  readonly fullName = input<string>('');

  protected readonly displayFirstName = computed(() =>
    this.fullName() ? (this.fullName().split(' ')[0] ?? '') : this.firstName(),
  );
  protected readonly displayLastName = computed(() =>
    this.fullName() ? (this.fullName().split(' ')[1] ?? '') : this.lastName(),
  );

  readonly COLORS_MAP = AVATAR_COLORS_MAP;
  readonly SIZES_MAP = AVATAR_SIZES_MAP;
}
